import type { QuizSuccessProps } from '@/components/quiz/components/quiz-success/quiz-success.types';
import { useTranslation } from 'react-i18next';
import { CircleCheckBig } from 'lucide-react';
import Control from '@/components/control';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { cn } from '@/utils/helper';
import v1 from '@/components/quiz/components/quiz-success/quiz-success-v1.module.css';
import v2 from '@/components/quiz/components/quiz-success/quiz-success-v2.module.css';

const QuizSuccess = (props: QuizSuccessProps) => {
  const { t } = useTranslation();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  return (
    <div className={cn(v1.QuizSuccess, v2.QuizSuccess)}>
      <div className={cn(v1.Content, v2.Content)}>
        <CircleCheckBig className={cn(v1.Icon, v2.Icon)} />
        <div className={cn(v1.Title, v2.Title)}>{t('Vielen Dank!')}</div>
        <div>{t('Wir haben Ihre Informationen erhalten und werden diese umgehend bearbeiten.')}</div>
        {cssVersion === 1 ? (
          <button type='button' className={cn(v1.Button, v2.Button)} onClick={props.onClick}>
            {t('Fenster schließen')}
          </button>
        ) : (
          <Control.Button color='next' size='md' type='button' onClick={props.onClick}>
            {t('Fenster schließen')}
          </Control.Button>
        )}
      </div>
    </div>
  );
};

export default QuizSuccess;
